module.exports = "/images/al.svg?b0e03f7dadd5086b269038c4fd35c6c2";